<style lang="less" scoped></style>
<template>
  <Modal
    v-model="show"
    persistent="true"
    dynamic-height
    title="薪资明细"
    max-width="1000"
    width="900"
    loading="loading"
    @on-ok="handleOk"
  >
    <div>
      <Table
        ref="table"
        :row-class-name="rowClassName"
        :columns="record_columns"
        :data="records"
        :loading="loading"
        no-data-text="暂无数据"
        size="small"
      />
    </div>
  </Modal>
</template>
<script>
  // import Util, { getsafe } from '../../libs/util';
  import Util from '../../libs/util';
  import Modal from "@/vuetify_custom/v-modal_v1";

  export default {
    name: "InformalWageDetailModal",
    components: [
      Modal,
    ],
    data() {
      return {
        show: false,
        loading: false,
        records: [],
        team_id: null,
        record_id: null,
      };
    },
    computed: {
      record_columns() {
        return [
          {
            title: 'leader',
            key: 'director',
            align: 'center',
            width: 80,
            fixed: 'left',
          },
          {
            title: '团队',
            key: 'team_name',
            align: 'center',
            width: 80,
            fixed: 'left',
          },
          {
            title: '税前日薪',
            key: 'daily_wage',
            align: 'center',
            width: 60,
            
          },
          {
            title: '每日餐补',
            key: 'daily_subsidy',
            align: 'center',
            width: 80,
          },
          {
            //   title: '计薪天数（远程+现场）',
            renderHeader(h) {
              return h('div', {}, [h('div', {}, '计薪天数'), h('div', {}, '（远程+现场）')])
            },
            key: 'work_days',
            align: 'center',
            width: 100,
            render: this.daysRender({dis_key:'work_days' })
          },
          {
            title: '餐补天数',
            key: 'subsidy_days',
            align: 'center',
            width: 90,
            render: this.daysRender({dis_key:'subsidy_days'})
          },
          {
            title: '奖金(￥)',
            key: 'bonus',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const ret = [];
              ret.push(h('span', ' ' + this.$util.formatPrice(params.row.bonus)));
              return h('div', ret);
            }
          },
          {
            title: '提成(￥)',
            key: 'commission',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const ret = [];
              ret.push(h('span', ' ' + this.$util.formatPrice(params.row.commission)));              
              return h('div', ret);
            }
          },
          {
            title: '扣除(￥)',
            key: 'deductions',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const ret = [];
              ret.push(h('span', ' ' + this.$util.formatPrice(params.row.deductions)));
              return h('div', ret);
            }
          },
          {
            renderHeader:(h) => {
              return h('span', ['其他发放(￥)', h('Tooltip', {
                props: {
                  content:"填写前请补充备注！",
                  placement:"top"
                }
              }, [h('Icon', {
                props: {
                  type:'md-help-circle',
                  size:14
                }
              })])])
            },
            title: '其他发放(￥)',
            key: 'other_bonus',
            align: 'center',
            width: 120,
            render: (h, params) => {
              const ret = [];
              ret.push(h('span', ' ' + this.$util.formatPrice(params.row.other_bonus)));              
              return h('div', ret);
            }
          },
          {
            title: '税前工资',
            key: 'total_wage',
            align: 'center',
            width: 80,
            render: (h, params) => {
              return h('span', '￥' + this.$util.formatDecimal(params.row.pre_tax_wage));
            }
          },
          {
            title: "备注",
            key: 'desc',
            width: 180,
            align: 'left',
            render: (h, params) => {
              const ret = [];
              ret.push(h('span', ' ' + params.row.desc));              
              return h('div', ret);
            }
          }
        ]
      }
    },
    watch: {},
    methods: {
      rowClassName(row) {
        // 废弃
        if (row.status === 7) {
          return 'color-error';
        }
        return '';
      },
      edit(id) {
        this.show = true;
        this.record_id = id;
        this.refreshList(id)
      },
      refreshList(id) {
        if (!this.record_id && !id) return Promise.resolve([]);
        return Util.ajax.get(Util.api.informal_wage_topic_record_detail_list, {
          params: {
            record_id: id || this.record_id
          }
        }).then((response) => {
          this.records = response.data.data;
          return response.data.data;
        }).finally(() => {
          this.$emit("refresh");
        });
      },
      handleOk() {
        this.show = false;
      },
      saveRecords(index) {
        const record = this.records[index]
        // 寻找当前用户条目
        const query = {
          detail_id: record.id,
          should_clock_day: record.should_clock_day, // 应打卡天数
          work_days: record.work_days, // 计薪天数
          subsidy_days: record.subsidy_days, // 餐补天数
          bonus: record.bonus, // 奖金
          commission: record.commission, // 提成
          deductions: record.deductions, // 扣除
          other_bonus: record.other_bonus, // 其他发放
          desc: record.desc, // 备注
        }
        return Util.ajax.post(Util.api.informal_wage_topic_record_detail_update, query).then(() => {
          this.refreshList()
        })
      },
      daysRender({dis_key}) {
        return (h, params) => {            
          return h('div', this.$util.formatDecimal(params.row[dis_key]));
        }
      },
    },
  };

</script>